export const formatPhoneNumber = (
  phoneNumber: string,
  isLandline?: boolean,
): string => {
  if (phoneNumber.length === 8) {
    return phoneNumber
      .split(
        isLandline ? /^(.{2})(.{2})(.{2})(.{2}).*/ : /^(.{3})(.{2})(.{3}).*/,
      )
      .join(" ")
      .trim();
  }
  return phoneNumber;
};
